import http from "./http.js";

export default {
  userGet(payload) {
    return http.get(`/userget/${payload.action}/${payload.id}`);
  },
  userPost(payload) {
    return http.post("/userpost", { payload });
  },
  userUpload(files) {
    return http.post("/userupload", files, {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${files._boundary}`,
      },
    });
  },
  clearmentPost(payload) {
    return http.post("/clearmentpost", { payload });
  },
  clearmentGet(payload) {
    return http.get(`/clearmentget/${payload.action}/${payload.id}`);
  },
  clearmentUpload(files) {
    return http.post("/clearmentupload", files, {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${files._boundary}`,
      },
    });
  },


};
 